'use client'

import React from 'react'
import { Heading } from '@/components/ui/heading'
import { ShardGrid } from '@/components/ShardGrid'
import { Eyebrow } from '@/components/Eyebrow'
import { LinkButton } from '@/components/ui/LinkButton'
import { HorizontalSplit } from '@/components/HorizontalSplit'

export function GrowTogetherClient() {
  return (
    <HorizontalSplit
      left={
        <div className="flex flex-col gap-[30px]">
          <Eyebrow label="Grants" color="punch" variant="dark" />
          <Heading responsive={false} size="h2" className="text-dark max-w-[500px] text-balance">
            Let’s grow Sia together.
          </Heading>
          <div>
            <LinkButton href="/grants" variant="punch">
              Apply Now
            </LinkButton>
          </div>
        </div>
      }
      rightClassName="py-[30px] overflow-hidden"
      right={<ShardGrid className="h-full" minGapSize={50} />}
    />
  )
}
